import { Card, Loading } from '@components'
import { useService } from 'solid-services'
import { For, Suspense } from 'solid-js'
import { grid } from 'styled-system/patterns'
import SetupCard from '../../Setups/List/Card'
import { useSetups } from './state'

export default function () {
	const { currentSetups } = useService(useSetups)()

	return (
		<Card.Root
			class={grid({
				gridTemplateRows: 'auto 1fr',
				height: 'calc(var(--vh) * 100 - 122px)',
				overflowY: 'auto',
			})}
		>
			<Card.Body
				class={grid({
					pt: 4,
					gridTemplateColumns: {
						base: 'repeat(auto-fill, minmax(330px, 1fr))',
					},
					justifyItems: 'center',
					alignItems: 'center',
				})}
			>
				<Suspense fallback={<Loading fill />}>
					<For each={currentSetups()()}>
						{(item) => (
							<SetupCard
								hideEditButton
								layout="image"
								setup={item as any}
							/>
						)}
					</For>
				</Suspense>
			</Card.Body>
		</Card.Root>
	)
}
